import Cliser from 'cliser';
import EditViewModel, { DEFAULT_SETTINGS_CONST } from 'models/EditViewModel';
import React from 'react';

import AlgorithmSettings from 'components/AlgorithmSettings';
import Camera from 'components/Camera';
import Checkbox from 'components/Checkbox';
import ConfigChangeTracker from 'components/ConfigChangeTracker';
import ConfigPrint from 'components/ConfigPrint';
import Control from 'components/Control';
import GaugeCanvas from 'components/GaugeCanvas';
import SetValueCheck from 'components/SetValueCheck';
import Slider from 'components/Slider';
import Tabs from 'components/Tabs';
import View from 'components/View';
import ConfigNoteEdit from 'components/configNoteEdit';
import Config from 'config';
import history from 'config/history';
import Modal from 'react-modal';
import Utils from 'utils';

const minrestartDeviceSwVersion = "1.2.8"
const minGainControlSwVersion = "1.2.13"

export default class EditView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'camera',
      confirm: false,
      unreliable: false,
      setValueModalOpen: false,
      rebootDeviceModalOpen: false,
      comparison: null,
      configReason: "-1",
      configNote: "",
      configCheckLater: false,
      configNotePublic: "",
      unreliableMeter: false,
      unreliableInfo: {
        configReason: "-1",
        comment: ""
      },
      unreliableDeviceModalOpen: false,
    };
  }

  reloadView() {
    if (this.session) {
      this.session.close();
    }

    this.session = Cliser
      .open()
      .use(EditViewModel)
      .listen("EditViewModel", (state) => {
        this.setState(state);
        if (state && state.config && state.config.device && state.config.device.meta) {
          this.setState({ configNotePublic: state.config.device.meta.configNote });
        }
        // console.log('CC',state)
        if (state.deviceId && state.premise &&
          state.premise.devicesinfo &&
          state.premise.devicesinfo[state.deviceId] &&
          state.premise.devicesinfo[state.deviceId].unreliableInfo &&
          state.premise.devicesinfo[state.deviceId].unreliableInfo.resolution) {
          this.setState({
            suggestChangeWaterMeter: state.premise.devicesinfo[state.deviceId].unreliableInfo.suggestChangeWaterMeter,
            unreliableReasonText: state.premise.devicesinfo[state.deviceId].unreliableInfo.unreliableReasonText
          });
        }
        if (state && state.config && state.config.device) {
          let resolution = this.calculateDevicePrecision(state.config.device);
          //console.log("Device resolution:", resolution);
          if (resolution >= 0.1) {
            this.setState({ unreliable: true });
            //console.log("unreliable meter!");
          } else {
            //console.log("meter precision ok");
            this.setState({ unreliable: false });
          }
        }
      });
    this.model = this.session.EditViewModel;
    this.model.resetError()

    if (this.props.params.id) {
      console.log('params id', this.props.params.id)
      this.model.loadDevice(this.props.params.id);
      this.setState({ inputDeviceId: this.props.params.id, confirm: false });
    } else {
      this.model.getState().then((state) => {
        console.log('state id', state.deviceId)
        this.model.loadDevice(state.deviceId);
        this.setState({ inputDeviceId: state.deviceId });
      })
    }


  }

  componentWillMount() {
    console.log("EditViewWillMount");
    this.reloadView();
    //Cliser.LoginModel.getGToken();
  }

  componentDidUpdate(prevProps) {
    if (this.props.params.id !== prevProps.params.id) {
      //this.setState({inputDeviceId: this.props.params.id});
      //this.model.loadDevice(this.props.params.id);
      this.reloadView();
    }
  }

  componentWillUnmount() {
    console.log("EditViewWillUNMount");
    this.session.close();
  }

  handleReportConfirmChange = (event, val) => {
    this.setState({ confirm: !this.state.confirm, unreliable: val });
  }
  handleReportsuggestChangeWaterMeter = (event) => {
    this.setState({ suggestChangeWaterMeter: event.target.checked });
  }

  calculateDevicePrecision = (device) => {
    let valuePrecision = null;
    const s = device.settings;
    if (s && s.data) {
      if (s.device && s.device.model && s.device.model === "combinedecimals") {
        let pointerPrecision = parseFloat(s.decimals.positions[s.decimals.positions.length - 1].precision);
        let digitPrecision = parseFloat(s.digits.positions[s.digits.positions.length - 1].precision);
        console.log("Presision p:", pointerPrecision, " d:", digitPrecision);
      } else {
        const valueToUse = parseInt(s.data.valueToUse, 10) || 0;
        if (valueToUse == 0) {
          if (s.decimals && s.decimals.positions) {
            if (s.decimals.rounding) valuePrecision = parseFloat(s.decimals.rounding);
            else if (s.decimals.positions.length === 2
              && parseFloat(s.decimals.positions[0].precision) == 0.0001
              && parseFloat(s.decimals.positions[1].precision) == 0.1) {
              valuePrecision = 0.01;
            } else if (parseFloat(s.decimals.positions[0].precision) == 0.0001) {
              valuePrecision = 0.0001;
            } else {
              valuePrecision = parseFloat(s.decimals.positions[0].precision);
            }
          } else {
            console.log(`invalid settings.decimals at device ${device.id}`);
          }
        }
        else if (valueToUse == 1) valuePrecision = parseFloat(s.impulseReader && s.impulseReader.precision);
        else if (valueToUse == 2) valuePrecision = 1;
        else if (valueToUse == 3) valuePrecision = parseFloat(s.digits.positions[s.digits.positions.length - 1].precision);
        else if (valueToUse == 4) valuePrecision = parseFloat(s.smartMeter.precision);
        // else console.log('unknown precision value to use!');
      }
    }
    return valuePrecision;
  }


  handleSubmit = () => {
    const report = {
      premiseId: this.state.premise._id,
      deviceId: this.state.deviceId,
      value: !this.state.unreliable,
      suggestChangeWaterMeter: this.state.suggestChangeWaterMeter,
      resolution: this.calculateDevicePrecision(this.state.config.device),
      unreliableReasonText: this.state.unreliableReasonText
      //image: canvas.toDataURL('image/jpeg', 0.5)
    }
    this.model.reportUnreliableMeter(report);
    this.setState({ confirm: false });
  }

  handleSetValue = (val) => {
    let ok = true;
    let res;
    let integers = val.trim();
    if (integers.length > 0 && this.state.analyzedImage && this.state.analyzedImage.digits && this.state.analyzedImage.digits.integer && this.state.analyzedImage.digits.integer.rawValue) {
      res = Utils.compareSetValueToAlgorithm(val, this.state.analyzedImage.digits.integer.rawValue)
      ok = res.result;
    }
    if (ok) {
      this.model.setMeterValue(this.refs.integerInput.value, this.refs.decimalInput.value, this.state.deviceId)
    } else {
      this.setState({ setValueModalOpen: true, comparison: res });
    }

  }

  handleReboot = () => {
    this.setState({ rebootDeviceModalOpen: true });
  }

  handleRestart = () => {
    this.setState({ restartDeviceSWModalOpen: true })
  }

  handleConfigReasonChanged = (reason) => {
    this.setState({ configReason: reason });

    //console.log("handleConfigReasonChanged:", reason);
  }

  handleConfigCheckLaterChange = (check) => {
    this.setState({ configCheckLater: check });
    //console.log("handleConfigCheckLaterChange:", check);
  }

  handleConfigNoteChanged = (note) => {
    this.setState({ configNote: note });
    //console.log("handleConfigNoteChanged:", note);
  }

  checkMinVersion(version, minVersion) {
    try {
      let cversion = parseInt(version.split(".").join(''));
      let mversion = parseInt(minVersion.split(".").join(''));
      if (cversion >= mversion) return true
      return false;
    } catch (err) {
      console.log("ERROR checking min version.", err);
      return false
    }
  }

  handleConfigNotePublicChanged = (note) => {
    try {
      this.setState({ configNotePublic: note });
      let meta = this.state.config.device.meta;
      meta.configNote = note;
      console.log("PublicNote Meta:", meta);
      this.model.savePublicNoteToMetaData(JSON.stringify(meta));
    } catch (err) {
      console.error("Error saving public note:", err);
    }
  }

  unreliableMeterReasonChanged = (e) => {
    this.setState({ unreliableInfo: { ...this.state.unreliableInfo, configReason: e.target.value } });
  }

  unreliableMeterCommentChanged = (e) => {
    this.setState({ unreliableInfo: { ...this.state.unreliableInfo, comment: e.target.value } });
  }

  saveMarkMeterUnreliable = () => {
    //console.log("Marking meter unreliable");
    const report = {
      premiseId: this.state.premise._id,
      deviceId: this.state.deviceId,
      value: this.state.unreliable,
      suggestChangeWaterMeter: this.state.unreliableInfo.configReason,
      resolution: this.calculateDevicePrecision(this.state.config.device),
      unreliableReasonText: this.state.unreliableInfo.comment
      //image: canvas.toDataURL('image/jpeg', 0.5)
    }
    this.model.reportUnreliableMeter(report);
    if (!this.state.openServiceRequests.length) {
      //console.log("Create service request")
      this.model.createServiceRequest(this.state.unreliableInfo.configReason, this.state.unreliableInfo.comment);
    }
    this.model.saveSettingsToDevice(this.state.lifecycleState, { configReason: this.state.configReason, configNote: this.state.configNote, configCheckLater: this.state.configCheckLater });
    this.setState({
      configReason: "-1",
      unreliableDeviceModalOpen: false,
      unreliableInfo: {
        configReason: "-1",
        comment: ""
      }
    });
  }

  saveSettingsToDevice = () => {

    const unreliable = this.state.deviceId &&
      this.state.premise &&
      this.state.premise.devicesinfo &&
      this.state.premise.devicesinfo[this.state.deviceId] &&
      this.state.premise.devicesinfo[this.state.deviceId].unreliable;

    if (this.state.unreliable && this.state.unreliableInfo.configReason === "-1" && !unreliable) {
      this.setState({ unreliableDeviceModalOpen: true });
      return;
    }

    //console.log("Saving settings unreliable:", unreliable);
    if (unreliable) {
      //mark meter reliable again.
      const report = {
        premiseId: this.state.premise._id,
        deviceId: this.state.deviceId,
        value: this.state.unreliable,
        resolution: this.calculateDevicePrecision(this.state.config.device),
        //image: canvas.toDataURL('image/jpeg', 0.5)
      }
      this.model.reportUnreliableMeter(report);
    }
    this.model.saveSettingsToDevice(this.state.lifecycleState, { configReason: this.state.configReason, configNote: this.state.configNote, configCheckLater: this.state.configCheckLater });
    this.setState({ configReason: "-1" })
  }

  getCameraVersion = () => {
    if (this.state.deviceHw) {
      if (this.state.deviceHw.length === 19) {
        try {
          let ver = this.state.deviceHw.split('-')[2].charAt(0);
          return ver;
        }
        catch (err) { }
      }
    }
    return 0;
  }

  autoConfigDisabled = () => {
    const config = this.state.config
    const settings = config && config.device.settings;
    if (settings && settings.device && settings.device.disableAutoConfig) {
      return true;
    }
    return false;
  }

  render() {
    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
      }
    };

    const messages = {
      connectingDevice: 'Connecting device...',
      loadingImage: <div style={{ textAlign: "center" }}>Loading image...<div><img src="/client/loader.gif" /></div></div>,
      analyzing: 'Analyzing...',
      settingSource: 'Setting image source...',
      saving: 'Saving...',
      rebooting: 'Sending reboot command to device...',
      waiting: 'Waiting 90 seconds for device reboot...',
      autoconfig: 'Auto config running...'
    };
    const message = messages[this.state.status] || this.state.status;

    const config = this.state.config
    const settings = config && config.device.settings;
    let showDigitSettings = true
    if (settings && settings.digits && settings.digits.algoVersion) {
      showDigitSettings = settings.digits.algoVersion != 'mlreaderjs';
    }
    const data = this.state.config ? {
      name: Utils.getSafely(this.state, 'config.device.name'),
      redTargetPercentage: Utils.getSafely(settings, 'decimals.redTargetPercentage')
    } : null;
    let deviceVersion = '-';
    let deviceSwName = '-';
    let lifecycleState = '-';
    let lifecycleOk = true;
    let allowUnreliableValues = settings && settings.data && settings.data.allowUnreliableValues ? "Allow Unreliable Values is Active" : ''
    let weakNetworkDevice = false;
    let multipleClients = this.state.multipleClients ? 'Multiple clients' : null;

    if (config && config.device && config.device.tag.match(/weaknetwork/)) {
      weakNetworkDevice = true;
    }

    if (data) {
      deviceVersion = (this.state.deviceVersion) ? this.state.deviceVersion.appVersion : '-';
      deviceSwName = (this.state.deviceVersion) ? this.state.deviceVersion.appName : '-';
      lifecycleState = (this.state.lifecycleState) ? this.state.lifecycleState : '-';
      lifecycleOk = (lifecycleState === '-' || lifecycleState === 'delivered' || lifecycleState === 'active');
    }


    const unreliable = this.state.deviceId &&
      this.state.premise &&
      this.state.premise.devicesinfo &&
      this.state.premise.devicesinfo[this.state.deviceId] &&
      this.state.premise.devicesinfo[this.state.deviceId].unreliable;
    const unreliableFormText = unreliable ? 'Report this meter as reliable again' : 'Report this meter as unreliable';
    const unreliableText = unreliable ? 'Unreliable' : null
    /*
    const salesPersonExists = this.state.deviceId &&
      this.state.premise &&
      this.state.premise.salesPerson;
    */
    const setSetting = (path) => (value) => {
      //console.log("DEBUG:", path, value);
      this.model.setSetting(path, value)
    };

    const deleteSetting = (path) => {
      //console.log("Debug deleteSetting:", path);
      this.model.setSetting(path);
    }

    const autoConfig = () => {
      this.model.autoConfig();
    }

    const setTerminalState = (state) => {
      console.log("setTerminalState:", state);
      this.model.setTerminalState(state);
    }


    const SendDataBadge = (props) => {
      let { value, ...others } = props;
      others.onClick = () => this.model.setDataSend(!value);
      if (value) {
        return <span className="badge-on" {...others} style={{ cursor: 'pointer' }}>sendData on</span>;
      }
      return <span className="badge-off" {...others} style={{ cursor: 'pointer' }}>sendData off</span>;
    };
    const analyzeLink = Config.links.analyzeLink + this.state.deviceId;
    const checkUpdateLink = Config.links.checkUpdateLink + this.state.deviceId;
    const serviceRequestLink = Config.links.serviceRequestLink + this.state.deviceId;
    const IdForm = (
      <div>
        <nav id="primary_nav_wrap">
          <ul>
            <li><a>More...</a>
              <ul>
                <li>
                  <a href={serviceRequestLink} target="_blank">Service request</a>
                </li>
                <li>
                  <a href={checkUpdateLink} target="_blank">Check update</a>
                </li>
                <li>
                  <a onClick={() => this.handleReboot()}>Reboot device</a>
                </li>
                {
                  (this.checkMinVersion(deviceVersion, minrestartDeviceSwVersion) || deviceSwName === "flowone-mlt3" || deviceSwName === "flowone-mlt4") && <li>
                    <a onClick={() => this.handleRestart()}>Restart device application</a>
                  </li>
                }
              </ul>
            </li>
          </ul>

          <div style={{ display: 'inline-block' }}>
            <span className="badge-neutral"><a href={analyzeLink} target="_blank">Open in Analyze</a></span>
          </div>
          <div style={{ display: 'inline-block' }}>
            {this.state.deviceConnectionStatus ? <span className="badge-on">Connected</span> : <span className="badge-off">Disconnected</span>}
            <SendDataBadge value={Utils.getSafely(this.state, 'deviceValues.sendData')} />
          </div>
          <form style={{ display: 'inline-block' }} onSubmit={(e) => { e.preventDefault(); history.push('/' + this.state.inputDeviceId); }}>
            <input value={this.state.inputDeviceId} onChange={(evt) => this.setState({ inputDeviceId: evt.target.value })} size="8" />
            <button type="submit" disabled={this.state.process}>Load</button>
          </form>
        </nav>
      </div>
    );
    const tabControls = (
      <div>
        <div>
          Image source:&nbsp;
          <select onChange={(evt) => this.model.setImageSource(evt.target.value)}>
            <option value="stream">Device</option>
            <option value="database">Database</option>
          </select>
        </div>
        <div>
          <button onClick={() => this.model.reloadImage()}>Reload image</button>
          {this.state.activeTab === "camera" ? <div className="dummyAnalyzeButton"></div> : <button onClick={() => this.model.analyzeImage()}>Analyze</button>}
        </div>
      </div>
    );

    const analyzeButton = (
      <button onClick={this.model.analyzeImage}>Analyze</button>
    );

    let minGamma = 1;
    let maxGamma = 20;

    //auto config camera settings
    let canControlGamma = false;
    let isJuudasDevice = deviceSwName === "flowone-mlt4";
    let camVer = this.getCameraVersion();
    if (camVer === "G" || camVer === "H") {
      if (this.checkMinVersion(deviceVersion, minGainControlSwVersion) || deviceSwName === "flowone-mlt3" || deviceSwName === "flowone-mlt4") {
        canControlGamma = true;
      }
      if (!this.autoConfigDisabled()) {

        const config = this.state.config
        const settings = config && config.device.settings;
        //console.log("adjusting gamma setting for camera type:", camVer);
        minGamma = 72;
        maxGamma = 500;
        if (settings.camera.gamma < 72) {
          this.model.setSetting('camera.gamma', 200)
        }
        if (settings && settings.camera && settings.camera.resolution !== "1920x1080") {
          this.model.setSetting('camera.resolution', "1920x1080");
        }
      }
    }
    let canSave = false;


    if (this.state.configReason !== "-1") {
      canSave = true;
    }

    return (
      <View title={"" + (data ? ' ' + data.name : '')} unreliable={unreliableText} weaknetwork={weakNetworkDevice} multipleclients={multipleClients} warning={allowUnreliableValues} name={deviceSwName} version={deviceVersion} lifecycleState={lifecycleState} lifecycleOk={lifecycleOk} controls={IdForm}>
        {this.state.error && <div className="error">{this.state.error}</div>}
        {!data && <div className="message">{message}</div>}
        {
          data &&
          <div>
            <Modal
              isOpen={this.state.rebootDeviceModalOpen}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
              contentLabel="No Overlay Click Modal"
            >
              <h1>Reboot device?</h1>

              <br />
              <div className="button-group">
                <button onClick={() => { this.model.rebootDevice(); this.setState({ rebootDeviceModalOpen: false }) }}>Ok</button>
                <button onClick={() => this.setState({ rebootDeviceModalOpen: false })}>Cancel</button>
              </div>
            </Modal>

            <Modal
              isOpen={this.state.restartDeviceSWModalOpen}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
              contentLabel="No Overlay Click Modal"
            >
              <h1>Restart device SW?</h1>

              <br />
              <div className="button-group">
                <button onClick={() => { this.model.restartDeviceSw(); this.setState({ restartDeviceSWModalOpen: false }) }}>Ok</button>
                <button onClick={() => this.setState({ restartDeviceSWModalOpen: false })}>Cancel</button>
              </div>
            </Modal>

            <Modal
              isOpen={this.state.unreliableDeviceModalOpen}
              style={customStyles}
              shouldCloseOnOverlayClick={false}
              contentLabel="No Overlay Click Modal"
            >
              <h1>Unreliable meter!</h1>
              <br />
              <p>Meter precision is too low for leak detection.</p>
              <p>Please choose reason for low precision. Automatic service request will be created.</p>
              <br />
              <div>
                Reason class:&nbsp;
                <select onChange={(e) => this.unreliableMeterReasonChanged(e)}>
                  <option value="-1">Choose reason</option>
                  <option value="Broken device">Broken device</option>
                  <option value="Broken seal">Broken seal</option>
                  <option value="Configuration needed">Configuration needed</option>
                  <option value="Device not placed correctly">Device not placed correctly</option>
                  <option value="Device offline">Device offline</option>
                  <option value="Dirt on water meter glass">Dirt on water meter glass</option>
                  <option value="Dirt on water meter glass, meter change">Dirt on water meter glass, meter change</option>
                  <option value="Faulty water meter">Faulty water meter</option>
                  <option value="Impulse reader on water meter">Impulse reader on water meter</option>
                  <option value="Impulse reader on water meter, meter change">Impulse reader on water meter, meter change</option>
                  <option value="ML device change">ML device change</option>
                  <option value="Moisture on Water meter glass">Moisture on water meter glass</option>
                  <option value="Not readable digital meter, meter change">Not readable digital meter, meter change</option>
                  <option value="Other">Other</option>
                  <option value="Terminated contract">Terminated contract</option>
                  <option value="Weak network">Weak network</option>
                </select>
                <br />
                <br />
                Comment: <br /> <textarea rows={8} cols={50} onChange={(e) => this.unreliableMeterCommentChanged(e)}></textarea>
              </div>
              <br />
              <div className="button-group">
                <button disabled={this.state.unreliableInfo.configReason === "-1"} onClick={() => { this.saveMarkMeterUnreliable(), this.setState({ unreliableDeviceModalOpen: false }) }}>Save</button>
                <button onClick={() => this.setState({ unreliableDeviceModalOpen: false })}>Cancel</button>
              </div>
            </Modal>


            <Tabs onChange={(activeTab) => { this.setState({ activeTab }); this.model.resetError(); }} controls={tabControls}>

              <div id="camera" icon="photo_camera" title="Camera settings">
                <Camera
                  image={this.state.analyzedImage}
                  settings={settings}
                  message={message}
                  grid={true}
                  onRotationChange={setSetting('orientation')}
                  tab="camera"
                  onAutoConfig={autoConfig}
                  note={this.state.configNotePublic}
                  openServiceRequests={this.state.openServiceRequests}
                >
                  {
                    !!this.state.analyzedImage && this.state.analyzedImage.source === 'database' &&
                    <div>
                      Set image source to <b>Device</b> and use <b>reload image</b> to test camera settings.
                    </div>
                  }
                </Camera>
                <Control label="Rotation">
                  <Slider
                    defaultValue={settings.orientation}
                    min={-180} max={180} step={0.1}
                    onChange={setSetting('orientation')}
                  />
                </Control>
                <Control label="Exposure">
                  <Slider
                    defaultValue={settings.camera.exposure}
                    min={100} max={5000} step={100}
                    onChange={setSetting('camera.exposure')}
                  />
                </Control>
                <Control label="Brightness">
                  <Slider
                    defaultValue={settings.camera.brightness}
                    min={0} max={100} step={1}
                    onChange={setSetting('camera.brightness')}
                    postfix="%"
                  />
                </Control>
                <Control label="Contrast">
                  <Slider
                    defaultValue={settings.camera.contrast}
                    min={0} max={100} step={1}
                    onChange={setSetting('camera.contrast')}
                    postfix="%"
                  />
                </Control>
                <Control label="Saturation">
                  <Slider
                    defaultValue={settings.camera.saturation}
                    min={1} max={100} step={1}
                    onChange={setSetting('camera.saturation')}
                    postfix="%"
                  />
                </Control>
                <Control label="Sharpness">
                  <Slider
                    defaultValue={settings.camera.sharpness}
                    min={0} max={100} step={1}
                    onChange={setSetting('camera.sharpness')}
                    postfix="%"
                  />
                </Control>
                <Control label="Gamma correction">
                  <Slider
                    defaultValue={settings.camera.gamma}
                    min={minGamma} max={maxGamma} step={0.1}
                    onChange={setSetting('camera.gamma')}
                  />
                </Control>
                <Control label="White balance temperature">
                  <Slider
                    defaultValue={settings.camera.whiteBalanceTemperature}
                    min={0} max={15000} step={100}
                    onChange={setSetting('camera.whiteBalanceTemperature')}
                  />
                </Control>
                <Control label="Skip Frames">
                  <Slider
                    defaultValue={settings.camera.skipFrames ? settings.camera.skipFrames : 20}
                    min={0} max={100} step={1}
                    onChange={setSetting('camera.skipFrames')}
                  />
                </Control>
                <Control label="Frame count">
                  <Slider
                    defaultValue={settings.camera.frameCount ? settings.camera.frameCount : 1}
                    min={1} max={100} step={1}
                    onChange={setSetting('camera.frameCount')}
                  />
                </Control>
                <Control label="FPS">
                  <Slider
                    defaultValue={settings.camera.fps ? settings.camera.fps : 15}
                    min={1} max={100} step={1}
                    onChange={setSetting('camera.fps')}
                  />
                </Control>
                {canControlGamma && <Control label="Gain">
                  <Slider
                    defaultValue={settings.camera.gain ? settings.camera.gain : 0}
                    min={0} max={100} step={1}
                    onChange={setSetting('camera.gain')}
                  />
                </Control>}
                {isJuudasDevice && <div>
                  <Control label="Zoom factor">
                    <Slider
                      defaultValue={settings.camera.zoomFactor ? settings.camera.zoomFactor : 1}
                      min={1} max={5} step={0.1}
                      onChange={setSetting('camera.zoomFactor')}
                    />
                  </Control>
                  <Control label="Image quality">
                    <Slider
                      defaultValue={settings.camera.pictureQuality ? settings.camera.pictureQuality : 95}
                      min={1} max={100} step={1}
                      onChange={setSetting('camera.pictureQuality')}
                      postfix="%"
                    />
                  </Control>
                  <Control label="Exposure mode">
                    <select value={settings.camera.autoExposure ? settings.camera.autoExposure : "Aperture Priority Mode"} onChange={(e) => setSetting('camera.autoExposure')(e.target.value)}>
                      <option value="Aperture Priority Mode">Auto</option>
                      <option value="Manual Mode">Manual</option>
                    </select>
                  </Control>
                </div>
                }



              </div>
              <div id="algoSettings" icon="settings" title="Settings">
                <AlgorithmSettings
                  settings={settings}
                  setSetting={this.model.setSetting}
                  deleteSetting={this.model.deleteSetting}
                  deviceSwName={deviceSwName}
                  deviceSwVersion={deviceVersion}
                  runCustomCmd={this.model.sendCustomCmd}
                  terminalStateChange={setTerminalState}
                  camVer={camVer}
                />
              </div>

              <div id="decimal" icon="place" title="Decimal pointers">
                <GaugeCanvas
                  image={this.state.analyzedImage}
                  settings={settings}
                  message={message}
                  onChange={(pos) => this.model.setNewPositions(pos)}
                  pointerEdit
                  tab="decimal"
                />
                <Control label="Red target percentage">
                  <Slider
                    defaultValue={data.redTargetPercentage}
                    min={0.5} max={3.0} step={0.01}
                    onChange={setSetting('decimals.redTargetPercentage')}
                  />
                </Control>
                <Control label="Minimum Vector Distance">
                  <Slider
                    defaultValue={settings.decimals.minVectorDistance}
                    min={20} max={200} step={1}
                    onChange={setSetting('decimals.minVectorDistance')}
                  />
                </Control>

                <Control label="Algorithmic detection">
                  <Checkbox
                    checked={settings.decimals.enabled}
                    onChange={setSetting('decimals.enabled')}
                    label="Use algorithmic detection" />
                </Control>
                <Control label="Use manual coordinates">
                  <Checkbox
                    checked={settings.decimals.useCoords}
                    onChange={(value) => {
                      setSetting('decimals.useCoords')(value);
                      if (value) {
                        this.model.resetDecimalPositions();
                      }
                    }}
                    disabled={this.state.analyzeNeeded} />
                  {
                    !!settings.decimals.useCoords && (
                      <div>
                        <div className="help-text">
                          Move decimal pointers by dragging them by mouse.
                          You can adjust the active pointer (yellow) by arrow keys while holding shift key down.
                        </div>
                        <div className="buttons">
                          <button onClick={() => this.model.resetDecimalPositions()}>Reset positions</button>
                        </div>
                      </div>
                    )
                  }
                  {
                    !!this.state.analyzeNeeded && (
                      <div className="help-text">
                        <p>Pointer settings changed. Analyze the image first before enabling fixed coordinates.</p>
                        {analyzeButton}
                      </div>
                    )
                  }
                </Control>
                <Control label="Visible pointers">
                  {this.state.enabledPointers.map((ptr, idx) => {

                    return (
                      <div>
                        <Checkbox
                          key={idx}
                          className="inline-component"
                          label={ptr.precision}
                          checked={ptr.enabled}
                          disabled={!ptr.togglable}
                          onChange={(enabled) => this.model.setPrecisionEnabled(ptr.precision, enabled, 'decimals')}
                        />
                        {ptr.precision === 0.0001 &&
                          <span className="inline-component itronspan">
                            <Checkbox
                              checked={ptr.itronMode}
                              onChange={(enabled) => this.model.enableItronMode(ptr.precision, enabled)}
                              label="ITRON pointer"
                            />
                          </span>
                        }
                      </div>
                    )
                  })}
                </Control>
                {analyzeButton}
              </div>

              <div id="digits" icon="looks_one" title="Digits">
                <GaugeCanvas
                  image={this.state.analyzedImage}
                  settings={settings}
                  message={message}
                  onChange={(pos) => this.model.setNewPositions(pos)}
                  digitEdit
                  tab="digits"
                  autoConfigButton={() => { this.model.generateAutoConfig() }}
                  scaleUpButton={() => { this.model.scaleDigitPrecisionsUp() }}
                  scaleDownButton={() => { this.model.scaleDigitPrecisionsDown() }}
                  addLeftButton={() => { this.model.addDigitLeft() }}
                  addRightButton={() => { this.model.addDigitRight() }}
                />
                {showDigitSettings &&
                  <div>
                    <Control label="Algorithmic detection">
                      <Checkbox
                        checked={settings.digits.enabled}
                        onChange={setSetting('digits.enabled')}
                        label="Use algorithmic detection"
                      />
                      <Checkbox
                        checked={settings.digits.inverted}
                        onChange={setSetting('digits.inverted')}
                        disabled={settings.digits.redDigit}
                        label="Invert colors"
                      />
                    </Control>
                    <Control label="digit height">
                      <Slider
                        defaultValue={settings.digits.height}
                        min={20} max={60} step={1}
                        onChange={setSetting('digits.height')}
                      />
                    </Control>
                    <Control label="digit width">
                      <Slider
                        defaultValue={settings.digits.width}
                        min={5} max={60} step={1}
                        onChange={setSetting('digits.width')}
                      />
                    </Control>
                  </div>}

                <Control label="Visible digits">
                  <table>
                    <thead>
                      <tr>
                        <th>Precision</th><th>Inverted</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.enabledDigits.map((ptr, idx) => (
                        <tr key={idx}>
                          <td>
                            <Checkbox
                              label={ptr.precision}
                              checked={ptr.enabled}
                              disabled={!ptr.togglable}
                              onChange={(enabled) => this.model.setPrecisionEnabled(ptr.precision, enabled, 'digits')}
                            />
                          </td>
                          <td>
                            <Checkbox
                              label=" "
                              checked={ptr.inverted}
                              disabled={!ptr.enabled}
                              onChange={(inverted) => this.model.setPrecisionInverted(ptr.precision, inverted)}
                            />
                          </td>
                          <td className="inline-component itronspan">
                            <Checkbox
                              checked={ptr.itronMode}
                              onChange={(enabled) => this.model.enableItronMode(ptr.precision, enabled)}
                              label="ITRON pointer"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Control>
                {showDigitSettings && <div>
                  <Control label="Width of local contrast area">
                    <Slider
                      defaultValue={Number.isFinite(settings.digits.localContrastW) ? settings.digits.localContrastW : DEFAULT_SETTINGS_CONST.digits.localContrastW}
                      min={2} max={25} step={1}
                      onChange={setSetting('digits.localContrastW')}
                    />
                  </Control>
                  <Control label="Local contrast margin">
                    <Slider
                      defaultValue={Number.isFinite(settings.digits.localContrastMargin) ? settings.digits.localContrastMargin : DEFAULT_SETTINGS_CONST.digits.localContrastMargin}
                      min={0} max={0.8} step={0.01}
                      onChange={setSetting('digits.localContrastMargin')}
                    />
                  </Control>
                  <Control label="Allowed deviation from set height">
                    <Slider
                      defaultValue={Number.isFinite(settings.digits.thresholdForH) ? settings.digits.thresholdForH : DEFAULT_SETTINGS_CONST.digits.thresholdForH}
                      min={0} max={6} step={1}
                      onChange={setSetting('digits.thresholdForH')}
                    />
                  </Control>
                  <Control label="Allowed deviation from center of area">
                    <Slider
                      defaultValue={Number.isFinite(settings.digits.thresholdForC) ? settings.digits.thresholdForC : DEFAULT_SETTINGS_CONST.digits.thresholdForC}
                      min={0} max={10} step={1}
                      onChange={setSetting('digits.thresholdForC')}
                    />
                  </Control>
                  <Control label="Red digits">
                    <Checkbox
                      checked={Number.isFinite(settings.digits.redDigit) ? settings.digits.redDigit : DEFAULT_SETTINGS_CONST.digits.redDigit}
                      onChange={setSetting('digits.redDigit')}
                      label="Use red digits"
                    />
                  </Control>
                  <Control label="Luminance threshold (applicable to red digits only)">
                    <Slider
                      defaultValue={Number.isFinite(settings.digits.luminancethreshold) ? settings.digits.luminancethreshold : DEFAULT_SETTINGS_CONST.digits.luminancethreshold}
                      min={1} max={255} step={1}
                      onChange={setSetting('digits.luminancethreshold')}
                    />
                  </Control>
                  <Control label="Filters">
                    <Checkbox
                      checked={Number.isFinite(settings.digits.noiseReduction) ? settings.digits.noiseReduction : DEFAULT_SETTINGS_CONST.digits.noiseReduction}
                      onChange={setSetting('digits.noiseReduction')}
                      label="Use noise reduction filter"
                    />
                    <Checkbox
                      checked={Number.isFinite(settings.digits.cleaningFilter) ? settings.digits.cleaningFilter : DEFAULT_SETTINGS_CONST.digits.cleaningFilter}
                      onChange={setSetting('digits.cleaningFilter')}
                      label="Use cleaning filter"
                    />
                    <Checkbox
                      checked={Number.isFinite(settings.digits.smoothing) ? settings.digits.smoothing : DEFAULT_SETTINGS_CONST.digits.smoothing}
                      onChange={setSetting('digits.smoothing')}
                      label="Use smoothing filter"
                    />
                  </Control>
                </div>}
                {analyzeButton}
              </div>

              <div id="values" icon="mode_edit" title="Value correction">
                <Camera
                  image={this.state.analyzedImage}
                  message={message}
                  settings={settings}
                />
                <div className="row">
                  <div>
                    <h2>Values from the device</h2>
                    <table>
                      <tbody>
                        <tr>
                          <th>Digit integer</th>
                          <td>{this.state.deviceValues.digitInteger}</td>
                        </tr>
                        <tr>
                          <th>Digit decimal</th>
                          <td>{this.state.deviceValues.digitDecimal}</td>
                        </tr>
                        <tr>
                          <th>Pointers</th>
                          <td>{this.state.deviceValues.pointer}</td>
                        </tr>
                        <tr>
                          <th>Impulse</th>
                          <td>{this.state.deviceValues.impulse}</td>
                        </tr>
                        <tr>
                          <th>sendData</th>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <h2>Set values</h2>
                    <Control label="Integers">
                      <input ref="integerInput" type="number" />
                    </Control>
                    <Control label="Decimals">
                      <input ref="decimalInput" type="string" />
                    </Control>
                    <button onClick={() => this.handleSetValue(this.refs.integerInput.value)}>
                      Set
                    </button>
                  </div>
                </div>
                <Modal
                  isOpen={this.state.setValueModalOpen}
                  style={customStyles}
                  shouldCloseOnOverlayClick={false}
                  contentLabel="No Overlay Click Modal"
                >
                  <h1>Confirm set value</h1>
                  <h4>Detected result differs or could not get result:</h4>
                  <SetValueCheck values={this.state.comparison} />
                  <br />
                  <div className="button-group">
                    <button onClick={() => { this.model.setMeterValue(this.refs.integerInput.value, this.refs.decimalInput.value, this.state.deviceId); this.setState({ setValueModalOpen: false }) }}>Set</button>
                    <button onClick={() => this.setState({ setValueModalOpen: false })}>Cancel</button>
                  </div>
                </Modal>
              </div>

              {/*<div id="report" icon="report_problem" title="Unreliable meter" color={unreliable ? "#dd0" : false}>
                <div className="unreliableMeter">
                  {this.state.status && <h3>{messages[this.state.status]}</h3>}
                  {!this.state.status &&
                    (
                      <div>
                        <h3>{unreliableFormText}</h3>
                        <form ref="reportForm" onSubmit={e => { e.preventDefault(); this.handleSubmit(); }}>
                          <p>
                            {this.state.latestImageLink && <img className="unreliableMeterImage" src={this.state.latestImageLink} />}
                          </p>
                          <p>Resolution: {this.calculateDevicePrecision(this.state.config.device)}m3</p>
                          <p>
                            <input type="checkbox" name="confirm" defaultChecked={this.state.confirm} onChange={(e) => this.handleReportConfirmChange(e, unreliable)} />
                            Report this meter
                          </p>
                          <p>
                            <input type="checkbox" name="suggestChangeWaterMeter" defaultChecked={this.state.suggestChangeWaterMeter} onChange={(e) => this.handleReportsuggestChangeWaterMeter(e)} />
                            Suggest change water meter
                          </p>
                          <p>More Info<br />
                            <textarea rows="4" cols="30"
                              ref="unreliableReasonText"
                              value={this.state.unreliableReasonText}
                              onChange={(evt) => this.setState({ unreliableReasonText: evt.target.value })} />
                          </p>
                          <p>
                            <input type="submit" value="Submit" disabled={!this.state.confirm} />
                          </p>
                        </form>
                      </div>
                    )
                  }
                </div>
                </div>*/}

              <div id="code" icon="code" title="Config JSON">
                {
                  !message ?
                    <div>
                      <div className="buttons">
                        <hr />
                        <div className='configControlsContainer'>
                          <ConfigChangeTracker handleReasonChanged={(r) => { this.handleConfigReasonChanged(r) }}
                            handleNoteChange={(n) => this.handleConfigNoteChanged(n)}
                            handleCheckLaterChange={(l) => this.handleConfigCheckLaterChange(l)}
                          />
                          <hr />
                          <ConfigNoteEdit handleNoteChanged={(n) => this.handleConfigNotePublicChanged(n)} note={this.state.configNotePublic} />
                        </div>
                        <button className='saveToDeviceBtn' disabled={!canSave} onClick={() => { this.saveSettingsToDevice() }}>Save to device</button>
                        <hr />
                      </div>
                      <ConfigPrint
                        config={this.state.config && this.state.config.device.settings}
                        onChange={(config) => {
                          this.model.setSettings(config);
                          this.forceUpdate();
                        }} />

                    </div>
                    :
                    <div>{message}</div>
                }

              </div>

            </Tabs>

          </div>
        }
        {this.state.error && <div className="error">{this.state.error}</div>}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./client/views/EditView.js